/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFamilyMemberPinPathParameters } from 'api/actions/get-family-member-pin/get-family-member-pin-path-parameters';
import { GetFamilyMemberPinResponse } from 'api/actions/get-family-member-pin/get-family-member-pin-response';

type GetFamilyMemberPinQueryParameters = Record<string, any>;

/**
 * The path of the GetFamilyMemberPin action.
 */
export const getFamilyMemberPinActionPath = new SweetPath<keyof GetFamilyMemberPinPathParameters>(
  '/user/family/members/{userId}/pin',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetFamilyMemberPin actions.
 */
export default function createGetFamilyMemberPinAction(axios: AxiosInstance) {
  return function getFamilyMemberPinAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetFamilyMemberPinPathParameters;
    query?: GetFamilyMemberPinQueryParameters;
  }) {
    const path = getFamilyMemberPinActionPath.insert(parameters);

    return axios.get<GetFamilyMemberPinResponse, GetFamilyMemberPinResponse>(path, { params: query, headers });
  };
}
